import React from 'react';
import SpecificTrainingMain from '../training/specific-training/SpecificTrainingMain';
import { mapTrainingFieldsToProps } from '../training/mapTrainingFieldsToProps';
import { Module } from '../../types/AgilityTypes';
import { SpecificTrainingFields } from '../training/specific-training/Types';

const SpecificTraining = ({
  module,
}: {
  module: Module<SpecificTrainingFields>;
}) => {
  if (!module || !module.fields) {
    return null;
  }
  const specificCard = module?.fields?.specificCard?.[0];
  if (!specificCard?.fields) return null;
  return (
    <SpecificTrainingMain {...mapTrainingFieldsToProps(specificCard.fields)} />
  );
};

export default SpecificTraining;
